export default "__VITE_ASSET__341194fb__"